module.exports = __webpack_public_path__ + "fonts/Latinka-ThinItalic.71605126.ttf";